module.exports = __webpack_public_path__ + "img/zlcsback.f192d4c2.png";